import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

interface BrandingResponse {
  app_name: string;
  logo_light: string;
  logo_dark: string;
}

/**
 * Identità dell'applicazione: nome (→ <title> della pagina) e loghi
 * dell'header, configurabili da Amministrazione/Configurazione.
 *
 * Stesso pattern di ThemeService: endpoint pubblico letto PRIMA di Keycloak
 * (il titolo e il logo servono già sulla schermata di accesso), best-effort —
 * se il backend non risponde restano il titolo statico di index.html e gli
 * asset compilati.
 */
@Injectable({ providedIn: 'root' })
export class BrandingService {
  private http = inject(HttpClient);
  private title = inject(Title);

  readonly appName = signal('Saragraph');
  /** Data-URI configurati; stringa vuota = usa l'asset di default. */
  readonly logoLight = signal('');
  readonly logoDark = signal('');

  async init(): Promise<void> {
    const b = await firstValueFrom(
      this.http.get<BrandingResponse>('/api/v1/config/branding').pipe(
        catchError(() => of({ app_name: '', logo_light: '', logo_dark: '' })),
      ),
    );
    if (b.app_name) {
      this.appName.set(b.app_name);
      this.title.setTitle(b.app_name);
    }
    // Se è configurato un logo solo, vale per entrambi i temi: meglio un
    // logo pensato per l'altro sfondo che due identità diverse.
    this.logoLight.set(b.logo_light || b.logo_dark || '');
    this.logoDark.set(b.logo_dark || b.logo_light || '');
  }
}
